module.exports = __webpack_public_path__ + "static/media/signature.5aa91568.PNG";